import React from 'react';
import { connect } from 'react-redux';
import { t } from 'localization';
import IconBusy from 'assets/static/images/ic_busy.svg';
import { ERROR_BOOKING_NOT_FOUND, ERROR_CODE_BOOKING_EXPIRED } from 'constants/enum';
import './PageError.scss';
import { PageWrapper } from 'components/PageWrapper';

class PageError extends React.Component {
  componentDidUpdate (prevProps) {
    // eslint-disable-next-line react/destructuring-assignment
    if (prevProps.language !== this.props.language) {
      this.forceUpdate();
    }
  }

  render () {
    const { errorCode = ERROR_BOOKING_NOT_FOUND } = this.props;
    return (
      <PageWrapper>
        <div className='error-page'>
          <div className='error-page-content'>
            <div className='img'>
              <img src={IconBusy} alt='' />
            </div>
            <p className='error-msg'>{t(errorCode)}</p>
            <p className='error-msg'>
              {errorCode === ERROR_CODE_BOOKING_EXPIRED
                ? t('error_shared_contact_expired')
                : t('error_shared_contact_cancelled')}
            </p>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

const mapStateTopProps = (state) => ({
  language: state.app.language,
});

export default connect(mapStateTopProps, null)(PageError);
